import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatTypingIndicatorUtilityClass(slot) {
  return generateUtilityClass('MuiChatTypingIndicator', slot);
}
export const chatTypingIndicatorClasses = generateUtilityClasses('MuiChatTypingIndicator', ['root']);
const slots = {
  root: ['root']
};
export const useChatTypingIndicatorUtilityClasses = classes => composeClasses(slots, getChatTypingIndicatorUtilityClass, classes);